import { useState, createContext,  useContext, useEffect } from "react";
import { addQuestions, addQuestionUnit, allCategories, allCourses, createCategory, createCourse, createLesson, getAllLessonsByField, learnerPlacement, loadEvalQuestions, updateQuestionUnit, uploadFile } from "./lessons.services";


const LessonContext = createContext();

export const LessonContextProvider = ({children}) => {
   
    const [loading, setLoading] = useState();
    const [courses, setCourses] = useState([]);
    const [categories, setCategories] = useState([]);

    const uploadFiletoServer = async (fileData) => {
        try {
            const response = await uploadFile(fileData);
            const res = await response.json();
            const {url} = res;
            return url;
        } catch (error) {
            console.log({error});
        }
    }

    /** create new lesson */
    const createNewLesson = async (data, token) => {
        try {
            setLoading(true);
            const fileUrl = await uploadFiletoServer(data.documentFile);
            const videoUrl = await uploadFiletoServer(data.videoFile);
            const fullData = {...data, video: videoUrl, document: fileUrl};
            const response = await createLesson(fullData,token);
            const res = await response.json();
            setLoading(false);
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    /** create lesson category */
    const createNewCategory = async (data, token) => {
        try {
            setLoading(true)
            const fileUrl = await uploadFiletoServer(data.documentFile);
            const courseData = {...data, icon: fileUrl}
            const response = await createCategory(courseData, token);
            const res = await response.json();
            setLoading(false);
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    /** load all categories */
    const loadCategories = async () => {
        try {
            const response = await allCategories();
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    const getLessonsByCategory = async (category) => {
        try {
            const response = await getAllLessonsByField(category);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    const createNewCourse = async (data, token) => {
        try {
            const fileUrl = await uploadFiletoServer(data.documentFile);
            const courseData = {...data, poster: fileUrl}
            const response = await createCourse(courseData, token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    /** get all courses */
    const getAllCourses = async (signal) => {
        try {
            setLoading(true);
            const response = await allCourses(signal);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({error});
        }finally{
            setLoading(false);
        }
    }

    /** create lesson questions */
    const createLessonEval = async (id, token) => {
        try {
            const response = await addQuestions(id, token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    /** add question unit to eval */
    const addEvalQuestion = async (id, qUnit, token) => {
        try {
            setLoading(true);
            if (qUnit.documentFile) {
                const imageUrl = await uploadFiletoServer(qUnit.documentFile);
                let newData = {...qUnit, image: imageUrl}
                const response = await addQuestionUnit(id, newData, token);
                const res = await response.json();
                setLoading(false);
                return res;
            }
            const response = await addQuestionUnit(id, qUnit, token);
            const res = await response.json();
            setLoading(false);
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    /** update evaluation question */
    const updateEvaluationQuestion = async (id, qUnit, qId, token) => {
        try {
            const response = await updateQuestionUnit(id, qUnit, qId, token);
            const res = await response.json();
            console.log(res);
            return res;
        } catch (error) {
            console.log({error});
        }
    }

    /** get eval questions */
    const getEvalQuestions = async (id) => {
        try {
            setLoading(true);
            const response = await loadEvalQuestions(id);
            const res = await response.json();
            setLoading(false);
            return res;
        } catch (error) {
            setLoading(false)
           console.log({error}); 
        }
    }

    const placeLearner = async (token) => {
        try {
            const response = await learnerPlacement(token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({error})
        }
    }

    useEffect(() => {
        /** async anonymous function */
        ( async () => {
            const data = await getAllCourses();
            const catData = await loadCategories();
            setCourses(data);
            setCategories(catData);
        })()
        return () => {
            console.log('')
        }
    }, [])

    return (
        <LessonContext.Provider
            value={{
                loading,
                courses,
                categories,
                createNewLesson,
                getLessonsByCategory,
                createNewCourse,
                createNewCategory,
                loadCategories,
                getAllCourses,
                createLessonEval,
                addEvalQuestion,
                getEvalQuestions,
                updateEvaluationQuestion,
                placeLearner
            }}
        >
            {children}
        </LessonContext.Provider>
    )
}

export const useLesson = () => useContext(LessonContext);